'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var mapStateToProps = function mapStateToProps(state, _ref) {
  var id = _ref.id;

  /**
  The part of the state this container relies on is updated with async
  dispatches from sagas. Need protection against inconsistencies with
  non-batched updates. See
  https://github.com/reactjs/redux/issues/1415 and
  https://github.com/reactjs/react-redux/issues/292.
    For time being, protection will consist of inspecting existance of properties.
  Will pass values to component that it can deal with when these are not present
  in store.
    A more definitive fix will consist of updating related packages (react,
  react-redux, and redux) to a version where this is solved, or use other
  pacakges and solutions propsed in the discussions above.
  */
  var input = state.genericSettings.oldCFA.inputs[id];
  var value = input && input.value || '';
  return {
    value: value
  };
};

var mapDispatchToProps = {
  updateInputValue: _GenericSettings.updateInputValue
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_components.InputValueEditor);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/InputValueEditor/InputValueEditor.js
// module id = 1631
// module chunks = 0